import api from './auth'

// 获取工单列表
export const getWorkOrders = (params) => {
  return api.get('/work/workorders/', { params })
}

// 获取工单详情
export const getWorkOrder = (id) => {
  return api.get(`/work/workorders/${id}`)
}

// 创建工单
export const createWorkOrder = (data) => {
  return api.post('/work/workorders/', data)
}

// 更新工单
export const updateWorkOrder = (id, data) => {
  return api.put(`/work/workorders/${id}`, data)
}

// 删除工单
export const deleteWorkOrder = (id) => {
  return api.delete(`/work/workorders/${id}`)
}

// 获取统计信息
export const getWorkOrderStats = () => {
  return api.get('/work/workorders/stats')
}

// 获取过滤选项
export const getFilterOptions = async () => {

    // 如果特定接口失败，尝试使用备用接口
    try {
      console.log('尝试备用接口: /work/deployment/environments')
      const backupResponse = await api.get('/work/deployment/environments', {
        params: { per_page: 100, is_active: true }
      })

      // 格式化备用响应以匹配预期结构
      return {
        data: {
          environments: backupResponse.data || backupResponse.data?.environments || []
        }
      }
    } catch (backupError) {
      console.error('备用接口也失败:', backupError)
      throw error // 抛出原始错误
    }
}

// 获取工单分配用户列表（支持搜索）
export const getAssignUsers = (params) => {
  return api.get('/work/workorders/assign/users', { params })
}